import { WalletIcon } from '@repo/icons';

import { PaymentMethod } from '@features/reservation/constants';
import { type PaymentMethodConfig } from '@features/reservation/types';

import blik from '@assets/images/reservation/blik.webp';
import paynow from '@assets/images/reservation/paynow.svg';

export const PAYMENT_METHODS: PaymentMethodConfig[] = [
  {
    id: PaymentMethod.Wallet,
    icon: <WalletIcon className="text-brand" />,
    titleTranslationKey: 'reservations:payment_page.wallet',
  },
  {
    id: PaymentMethod.Paynow,
    icon: <img src={paynow} alt="PayNow" className="h-6 w-auto" />,
    titleTranslationKey: 'reservations:payment_page.paynow',
  },
  {
    id: PaymentMethod.Blik,
    icon: <img src={blik} alt="BLIK" className="h-6 w-auto" />,
    titleTranslationKey: 'reservations:payment_page.blik_with_code',
    labelTranslationKey: 'reservations:blik.code_label',
    hasExpandableContent: true,
  },
];
